import { createFileRoute } from '@tanstack/react-router'

import PagePlaygroundUpscale from '../pages/PagePlaygroundUpscale'

type PlaygroundRunSearch = {
  runId?: string
}

export const Route = createFileRoute('/playground/upscale')({
  component: PagePlaygroundUpscale,
  validateSearch: (search: Record<string, unknown>): PlaygroundRunSearch => ({
    runId: typeof search.runId === 'string' && search.runId.length > 0 ? search.runId : undefined
  })
})
